<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form :model="form" :rules="rules" ref="form" label-width="50px">
            <el-form-item label="正文" prop="value">
                <Editor v-model="form.value"></Editor>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 120px" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import Editor from "@/components/Editor";
import { detail, edit } from "@/api/content/privacy";
export default {
    components: {
        Language,
        Editor,
    },
    data() {
        return {
            form: {
                lang: "zh",
                value: "",
            },
            rules: {},
            add: true,
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.add = false;
                        this.form = { ...result, lang: this.form.lang };
                    } else {
                        this.add = true;
                        this.form = { lang: this.form.lang };
                    }
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleLangChange() {
            this.getDetail();
        },
        handleSave() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    lang: this.form.lang,
                    value: this.form.value,
                };
                edit(params).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("保存成功");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
